import { SetToothMPRSliceOptionsReq } from '@/shared/api/protocol-ts/api/core/svc_report_pb';
import {
  ToothMPRSliceOptions,
  ToothMPRSliceOptions_SeriesOptions,
} from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

import type { ToothSliceOptions, ToothSliceOptionsBySeries } from '../config';

const makeSeriesOptions = (options: ToothSliceOptions) =>
  new ToothMPRSliceOptions_SeriesOptions({
    SliceStepMm: options.sliceStepMm,
    ThicknessMm: options.thicknessMm,
  });

export const makeToothMPRSliceOptionsRequest = ({
  optionsBySeries,
  toothID,
}: {
  optionsBySeries: ToothSliceOptionsBySeries;
  toothID: string;
}): SetToothMPRSliceOptionsReq =>
  new SetToothMPRSliceOptionsReq({
    ToothID: toothID,
    Action: {
      case: 'SetOptions',
      value: new ToothMPRSliceOptions({
        Axial: makeSeriesOptions(optionsBySeries.axial),
        VestibuloOral: makeSeriesOptions(optionsBySeries.sagittal),
        MesioDistal: makeSeriesOptions(optionsBySeries.frontal),
      }),
    },
  });
